import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import ContentCardHeader from '../common/template/contentCardHeader';
import ContentCardBody from '../common/template/contentCardBody';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import ThSort from '../common/table/thSort';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import Button from '../common/button/button';
import Form from './pedidoForm';
import { setError } from '../common/toast/toast';
import readXlsxFile from 'read-excel-file/web-worker'
import Aguardando from '../common/template/aguardando';
import FormatUtils from '../common/formatUtils/FormatUtils';
import InputPesquisa from '../common/form/inputPesquisa';
import ReactExport from 'react-export-excel-fixed-xlsx';
import { sortData } from '../common/table/sortHelper';
import DateFormat from '../common/dateFormat/DateFormat';
import LabelAndInputDate from '../common/form/labelAndInputDate';

import {
	setModoTela, setFiltro, initForm, salvar, excluir, getLista, 
	getListaFormaPagamento, getListaTipoPagamento
} from './pedidoActions';
import { getLista as getListaProduto, getListaImagens as getListaImagensProduto, getListaTabelaPreco } from '../produto/produtoActions';
import { getListaBoletosPendentes, getLista as getListaCliente } from '../cliente/clienteActions';

const columns = [

];

class Pedido extends Component {

	state = {
		linhaSelecionada: null,
		sort: {
			field: 'data',
			direction: 'asc' // 'asc' | 'desc'
		}
	}

    componentWillMount() {
		this.props.setModoTela('lista');
        this.props.getLista();
		this.props.getListaCliente();
		this.props.getListaFormaPagamento();
		this.props.getListaTipoPagamento();
		this.props.getListaProduto();
		this.props.getListaTabelaPreco();
		this.props.getListaBoletosPendentes();

		this.idIntervalAtualizacao = setInterval(() => {
			this.props.getLista();
			this.props.getListaCliente();
			this.props.getListaFormaPagamento();
			this.props.getListaTipoPagamento();
			this.props.getListaProduto();
			this.props.getListaBoletosPendentes();
		}, 60000);
    }

	componentDidMount() {
		document.addEventListener('keydown', this.handleKeyDown);
	}

	componentWillUnmount() {
		document.removeEventListener('keydown', this.handleKeyDown);
		clearInterval(this.idIntervalAtualizacao);
		clearInterval(this.idIntervalAtualizacaoImagens);
	}

	handleKeyDown = (e) => {
		if (e.key === 'Enter' && this.botaoNovoPedido) {
			e.preventDefault();
			this.botaoNovoPedido.click();
		}
	};

    render() {
        return (
            <div>
                <Content>
					<Aguardando aguardando={this.props.aguardando} />

					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}

					{/* FLOAT ACTION BUTTON */}
					{(this.props.modoTela == 'lista') &&
					<button
						type='button'
						ref={button => this.botaoNovoPedido = button}
						onClick={() => {
							this.props.setModoTela('cadastro');
							this.props.initForm({});
						}}
						style={{
							position: 'fixed',
							right: 10,
							bottom: 60,
							width: 56,
							height: 56,
							borderRadius: '50%',
							border: 'none',
							background: '#28a745',
							color: '#fff',
							fontSize: 24,
							fontWeight: 'bold',
							boxShadow: '0 6px 18px rgba(0,0,0,0.25)',
							zIndex: 9999,
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'center'
						}}
					>
						<i
							className='fa fa-plus'
							style={{
								fontSize: 24
							}}
						/>
					</button>}

					{this.totalizador()}
					
                </Content>
            </div>
        )
    }

	filtrar() {
		const listaFiltrada = this.props.lista.filter(item => {
			return !(this.state.pesquisar || '').trim()
			|| (this.state.pesquisar.toUpperCase() || '')
				.split('+')
				.filter(p => p.trim())
				.every(pesquisar => `
					${item.razao_social_cliente}
					${item.nome_fantasia_cliente}
					${item.codigo_cliente}
					${item.cnpj_cliente || item.cpf_cliente || '-'}
					${item.nome_vendedor}
					${DateFormat.formatarDataSqlParaTela(item.datahora_pedido)}
					R$ ${FormatUtils.formatarValorTela(item.total_pedido, 2)}
					${item.nome_status}
				`.toUpperCase().includes(pesquisar)
				);
		});

		return listaFiltrada;
	}
	
	onSort(field) {
		this.setState(prev => {
			let direction = 'asc';

			if (prev.sort.field === field) {
				direction = prev.sort.direction === 'asc' ? 'desc' : 'asc';
			}

			return {
				sort: { field, direction }
			};
		});
	}

	lista() {

		const lista = this.filtrar();

		return (
			<div style={{ paddingBottom: 50 }}>
				<Row alignCenter>
					<InputPesquisa
						cols='12 12 12 12'
						label={null}
						onChange={value => this.setState({
							...this.state,
							pesquisar: value
						})}
					/>
					{/*window.innerWidth >= 1100 &&
					<div style={{ marginTop: 8, marginLeft: 8 }}>
						<a class='btn btn-app bg-success' style={{ marginLeft: 2, minWidth: 75 }}
							onClick={() => {
								this.props.setModoTela('cadastro');
								this.props.initForm({});
							}}>
							<i class='fas fa-plus'></i> Pedido
						</a>
					</div>*/}

					<LabelAndInputDate
						label='Data Inicial'
						cols='12 6 4 4'
						value={this.props.filtro.data_inicial}
						onChange={value => {
							this.props.setFiltro({
								...this.props.filtro,
								data_inicial: value
							});
							this.props.getLista();
						}} />

					<LabelAndInputDate
						label='Data Final'
						cols='12 6 4 4'
						value={this.props.filtro.data_final}
						onChange={value => {
							this.props.setFiltro({
								...this.props.filtro,
								data_final: value
							});
							this.props.getLista();
						}} />
				</Row>

				<div>

					{lista.map((item, i) => (

						<div
							key={item.id_pedido}
							style={{
								backgroundColor: '#fff',
								borderRadius: 16,
								marginBottom: 16,
								padding: 16,
								boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
								border: this.state.linhaSelecionada == item.id
									? '2px solid #5b7fff'
									: '1px solid #e5e5e5'
							}}
							onClick={e => {
								e.stopPropagation();
								this.props.setModoTela('cadastro');
								this.props.initForm({
									...item
								});
							}}
						>
							<div
								style={{
									fontSize: 14,
									fontWeight: 'bold',
									color: '#333',
									marginBottom: 4
								}}
							>
								{item.razao_social_cliente}
							</div>
							<div
								style={{
									fontSize: 12,
									color: '#333'
								}}
							>
								{item.nome_fantasia_cliente}
							</div>
							<div
								style={{
									display: 'flex',
									justifyContent: 'space-between'
								}} >
								<div>
									<div style={{ fontSize: 12, color: '#999' }}>
										Código
									</div>

									<div style={{ fontWeight: 600 }}>
										{item.codigo_cliente}
									</div>
								</div>

								<div style={{ textAlign: 'right' }}>
									<div style={{ fontSize: 12, color: '#999' }}>
										CPF / CNPJ
									</div>

									<div style={{ fontWeight: 600 }}>
										{item.cnpj_cliente || item.cpf_cliente || '-'}
									</div>
								</div>
							</div>

							<div
								style={{
									display: 'flex',
									justifyContent: 'space-between'
								}} >
								<div>
									<div style={{ fontSize: 12, color: '#999' }}>
										Vendedor
									</div>

									<div style={{ fontWeight: 600 }}
									>
										{item.nome_vendedor}
									</div>
								</div>

								<div style={{ textAlign: 'right' }}>
									<div style={{ fontSize: 12, color: '#999' }}>
										Data
									</div>

									<div style={{ fontWeight: 600 }}>
										{DateFormat.formatarDataSqlParaTela(item.datahora_pedido)}
									</div>
								</div>
							</div>

							<div
								style={{
									display: 'flex',
									justifyContent: 'space-between'
								}}
							>
								<div>
									<div style={{ fontSize: 12, color: '#999' }}>
										Valor
									</div>

									<div
										style={{
											color: '#2e7d32',
											fontWeight: 'bold',
											fontSize: 20
										}}
									>
										R$ {FormatUtils.formatarValorTela(item.total_pedido, 2)}
									</div>
								</div>

								<div style={{ textAlign: 'right' }}>
									<div style={{ fontSize: 12, color: '#999' }}>
										Status
									</div>

									<div
										style={{
											fontWeight: 'bold',
											fontSize: 18,
											color: item.finalizado ? '#076e00' : '#bdbf00',
										}}
									>
										{item.nome_status}
									</div>
								</div>
							</div>
						</div>
					))}
				</div>
			</div>
		);
	}

	totalizador() {

		if (this.props.modoTela != 'lista') {
			return null;
		}

		const lista = this.filtrar();

		let pedidos = 0;
		let valorTotal = 0;

		lista.forEach(item => {
			pedidos++;
			valorTotal += parseFloat(item.total_pedido);
		});

		return (
			<div
				style={{
					position: 'fixed',
					left: 0,
					right: 0,
					bottom: 0,
					height: 50,
					background: 'linear-gradient(135deg, #28a745, #20c997)',
					borderTopRightRadius: 4,
					borderTopLeftRadius: 4,
					boxShadow: '0 8px 24px rgba(0,0,0,.18)',
					zIndex: 9999,
					display: 'flex',
					alignItems: 'center',
					justifyContent: 'space-between',
					padding: '0 24px',
					color: '#FFF'
				}} >
				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						width: '50%'
					}} >
					<div
						style={{
							fontSize: 12,
							opacity: 0.9,
							fontWeight: 500
						}} >
						Pedidos
					</div>

					<div
						style={{
							fontSize: 18,
							fontWeight: 700
						}} >
						{pedidos}
					</div>
				</div>

				<div
					style={{
						width: 1,
						height: 40,
						background: '#ffffff'
					}} />

				<div
					style={{
						display: 'flex',
						flexDirection: 'column',
						alignItems: 'flex-end',
						width: '50%'
					}} >
					<div
						style={{
							fontSize: 12,
							opacity: 0.9,
							fontWeight: 500
						}} >
						Total (R$)
					</div>

					<div
						style={{
							fontSize: 18,
							fontWeight: 700
						}} >
						R$ {FormatUtils.formatarValorTela(valorTotal, 2)}
					</div>
				</div>

			</div>
		);
	}
}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	usuarioCarregado: state.auth.usuarioCarregado,
	modoTela: state.pedido.modoTela,
	filtro: state.pedido.filtro,
	aguardando: state.pedido.aguardando,
	lista: state.pedido.lista,
	listaImagens: state.pedido.listaImagens
});
const mapDispatchToProps = dispatch => bindActionCreators({ 
	setModoTela, setFiltro, initForm, salvar, excluir, getLista,
	getListaFormaPagamento, getListaTipoPagamento,
	getListaProduto, getListaImagensProduto, getListaTabelaPreco,
	getListaBoletosPendentes, getListaCliente
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(Pedido);
